import React from "react";
import "./ScrollTemp.css";
import { FiPlus, FiArrowRight } from "react-icons/fi";
import TemplateSkeleton from "../../Components/SkeletonLoader/TemplateSkeleton";
import { TEMPLATE_CATALOG } from "./templateCatalog";

export default function ScrollTemp({
  templatesList,
  template,
  setTemplate,
  setTemplateId,
  setNewProjectInputModalOpen,
  onCustomProjectClick,
  onTemplateClick,
  allTemplateLoading,
}) {
  const templateSkeletonCount = 6;

  const allTemplateSkelton = () =>
    Array.from({ length: templateSkeletonCount }, (_, i) => (
      <TemplateSkeleton key={`template-skeleton-${i}`} />
    ));

  const list =
    templatesList?.length > 0 ? templatesList : TEMPLATE_CATALOG;

  return (
    <div className="w-full flex items-stretch gap-4">
      {/* Custom Project — fixed in place, always the first tile */}
      <div
        className="tplCard tplCardCustom flex-shrink-0"
        onClick={onCustomProjectClick}
      >
        <div className="tplIconCircle">
          <FiPlus className="w-7 h-7" />
        </div>
        <span className="tplTitle tplTitleCustom font-body">
          Custom Project
        </span>
      </div>

      {/* Templates — horizontally scrollable */}
      <div className="tplScrollRow flex-1 min-w-0">
        {allTemplateLoading
          ? allTemplateSkelton()
          : list?.map((item, idx) => (
              <div
                className="tplCard"
                key={`${item?.label}-${item?.templateId ?? idx}`}
                onClick={() => {
                  setTemplateId(item?.templateId ?? item?.id);
                  if (setTemplate) setTemplate(false);
                  onTemplateClick?.(item);
                }}
              >
                <span className="tplBadge">
                  {item?.type || item?.badge || "SCROLL"}
                </span>
                <div className="tplCardBody">
                  <span className="tplTitle font-body">
                    {item?.label}
                  </span>
                  <p className="tplDesc">
                    {item?.shortDescription || item?.description || ""}
                  </p>
                </div>
                <div className="tplPreviewCue" aria-hidden="true">
                  Preview <FiArrowRight className="tplPreviewCue__icon" />
                </div>
              </div>
            ))}
      </div>
    </div>
  );
}
